import React from 'react';
import { useAuth } from '../../services/AuthContext';
import Card from '../ui/Card';
import { estadoLicenca } from '../../utils/statusLicenca';

const UserInfo = ({ subscription }) => {
  const { user } = useAuth();
  const estado = estadoLicenca(subscription);

  return (
    <Card className="p-6">
      <div className="flex items-center space-x-4">
        <div className="w-16 h-16 rounded-full bg-rn-navy-surface flex items-center justify-center">
          <span className="text-2xl font-semibold text-white">
            {user?.email?.[0].toUpperCase()}
          </span>
        </div>
        <div>
          <h2 className="text-xl font-semibold text-rn-navy mb-1">
            {user?.email}
          </h2>
          <p className="text-rn-text-soft">
            Membro desde {new Date(user?.created_at).toLocaleDateString()}
          </p>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-rn-bg rounded-lg p-4">
          <h3 className="text-sm font-medium text-rn-text-soft mb-1">
            Último Acesso
          </h3>
          <p className="text-rn-navy">
            {new Date(user?.last_sign_in_at).toLocaleString()}
          </p>
        </div>
        <div className="bg-rn-bg rounded-lg p-4">
          <h3 className="text-sm font-medium text-rn-text-soft mb-1">
            Status da Licença
          </h3>
          <p className={`${estado.cor} font-medium`}>
            {estado.texto}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default UserInfo;